<template>
	<div class="modal inmodal fade modal-v5" tabindex="-1" role="dialog" id="modalConnectFunnels">
		<div class="modal-dialog">
			<div class="modal-content" v-if="!loading">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                    <h2 class="modal-title font-mulish" v-text="translations.title_connect"></h2>
                </div>
                <div class="modal-body">
                    <form v-on:submit.prevent="connect()">
                        <div :class="['form-group', showInvalid && domain.length > 0 ? 'has-error' : '']"  id="mgc__div_url">
                            <label class="is-required font"> {{ `${translations.your_domain}:`}}</label>
                            <input type="text" :class="['form-control font-mulish', !showInvalid ? 'success-border': '']" placeholder="builderall.com" v-model="domain"/>
                            <span class="invalid pull-left" v-if="showInvalid">{{ `${errorMessage}`}}</span>
                            <br/>
                        </div>
                    </form>

                    <p class="info-text-connect font-mulish" v-html="translations.information"></p>
                    <div class="bottom-buttons">
                        <button class="btn btn-block is-primary" @click="buyDomain()">
                            <i class="fa fa-usd" aria-hidden="true"></i>
                            <span class="font-mulish">
                                {{' ' +  translations.buy_domain}} 
                            </span>
                        </button>
                        <button class="btn btn-block is-primary" @click="verifyDomain()" :disabled="showInvalid">
                            <i class="fa fa-globe" aria-hidden="true"></i>
                            <span class="font-mulish">
                                {{' ' + translations.connect}} 
                            </span>
                        </button>
                    </div>
                </div>

			</div>
			<div class="modal-content" v-else>
                <div class="modal-header">
                     <button type="button" class="close" data-dismiss="modal" aria-hidden="true" >&times;</button>
                    <br>
                </div>
                <div class="modal-body text-center">
                    <img class="modal-loader" src="/internacional/public/office4/img/dashboard/load-2.svg"/>
                </div>
            </div>
		</div>
	</div>
</template>

<script>
import qs from "qs";
export default {
    props:['route'],
    data() {
        return {
            loading: true,
            translations: {},
            lang: window.lang || 'us',
            domain: '',
            showValid: false,
            searching: false,
            showInvalid: true,
            errorMessage: '',
        };
    },
    methods:{
        initialize(){
            this.loadData();
        },
        loadData(){
            let vm = this;
            vm.loading = true;
            axios
                .get(`/${vm.lang}/office/funnels/connect-domain/get-data`)
                .then((response)=>{
                    if(response.data.success){
                        vm.translations = response.data.data.translations;
                    }
                })
                .catch((error)=>{
                    console.error(error);
                })
                .finally(()=>{
                    vm.loading = false;
                });
        },
        buyDomain() {
            window.open(`/${this.lang}/office/buy-domain?ac=1`);
        },
        verifyDomain() {
            if(!this.searching)
            {
                this.searching = true;
                const token = "ba-d301c0cb406b7ce501b860a87fde074879794645a";
                var requestOptions = {
                    method: 'GET',
                    redirect: 'follow'
                };
                fetch("https://dns.builderall.com/api/domain/validate-name?d="+this.domain+"&t="+token, requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if(result.success && result.is_valid)
                        {
                            // alertMsg("success",this.translations.valid_domain_connecting);
                            this.connect();
                        }
                        else
                        {
                            alertMsg("error",this.translations.error_connecting_domain);
                        }
                    })
                    .catch(error => {console.log('error', error)})
                    .finally(this.searching = false)
            }
        },
        connect() {
            let vm = this;

            if(vm.domainEmpty){
                return;
            }
            
            vm.loading = true;

            axios
                .post(`/${vm.lang}/office/franchise-system/connect`, { domain: vm.domain })
                .then((response)=>{
                    if(response.data.success){
                        alertMsg("success", vm.translations.success)
                        vm.showValid = true
                        vm.showInvalid = false

                        vm.treatRedir();
                        vm.close()
                    }else{
                        // alertMsg("error", response.data.message)
                        vm.errorMessage = response.data.message
                        vm.showValid = false
                        vm.showInvalid = true
                    }
                })
                .catch((error)=>{
                    alertMsg("error", vm.translations.error)
                    vm.showValid = false
                    vm.showInvalid = false
                    console.error(error);
                })
                .finally(()=>{
                    vm.loading = false;
                });
        },
        close(){
            $('#modalConnectFunnels').modal('hide');
        },
        treatRedir(){
            let url =  window.location.href;
            url = this.removeUrlParam('opentool', url);
            url = this.setUrlParam(url, 'connected-domain', this.domain);
            window.location.href = url;
        },
        removeUrlParam(key, sourceURL) {
            var rtn = sourceURL.split("?")[0],
                param,
                params_arr = [],
                queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
            if (queryString !== "") {
                params_arr = queryString.split("&");
                for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                    param = params_arr[i].split("=")[0];
                    if (param === key) {
                        params_arr.splice(i, 1);
                    }
                }
                if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
            }
            return rtn;
        },
        setUrlParam(url, param, paramVal, setHowLast) {
            var urlSplited    = url.split('#'),
                parts         = urlSplited[0].split('?'),
                baseUrl       = parts[0],
                newParameters = [];

            // cast boolean
            setHowLast = !!setHowLast;

            if(parts.length > 2) {
                // concatenate extra parts
                for(var i=2, len=parts.length; i<len; i++) {
                    parts[1] += ('&' + parts[i]);
                }

                // remove extra parts
                for(var i=2, len=parts.length; i<len; i++) {
                    parts.pop();
                }
            }

            if(!setHowLast) {
                if (paramVal !== '' && paramVal !== null && typeof paramVal !== 'undefined') {
                    var paramValue = param == 'redir' ? paramVal : encodeURI(paramVal);
                    newParameters.push(param + '=' + paramValue);
                }
            }

            for(var i=1, len=parts.length; i<len; i++) {

                var oldQueryString = parts[i];
                if(!!oldQueryString) {
                    var oldParameters = oldQueryString.split('&');
                    for (var i = 0; i < oldParameters.length; i++) {
                        if(oldParameters[i].split('=')[0] != param) {
                            newParameters.push(oldParameters[i]);
                        }
                    }
                }
            }

            if(setHowLast) {
                if (paramVal !== '' && paramVal !== null && typeof paramVal !== 'undefined') {
                    var paramValue = param == 'redir' ? paramVal : encodeURI(paramVal);
                    newParameters.push(param + '=' + paramValue);
                }
            }

            if (newParameters.length > 0) {
                baseUrl += '?' + newParameters.join('&');
            }

            if(urlSplited.length == 2) {
                baseUrl += '#' + urlSplited[1];
            }

            return baseUrl;
        }
    },
    mounted(){
        this.initialize();
    },
    watch: {
        domain(newVal, oldVal){
            if(newVal && newVal.length > 0 && newVal != oldVal)
            {
                this.domain = newVal.toLowerCase().trim(); 
                if(/^[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,15}(:[0-9]{1,5})?(\/.*)?$/.test(this.domain))
                {
                    this.showInvalid = false;
                    this.showValid = false;
                    this.errorMessage = '';
                } 
                else 
                {
                    this.showInvalid = true;
                    this.showValid = false;
                    this.errorMessage = '';
                }
            } 
            else 
            {
                this.showInvalid = true;
                this.showValid = false;
                this.errorMessage = '';
            }
        },
    },
    computed: {
        domainEmpty(){
            return !this.domain || this.domain.lenght < 1;
        }
    }

}
</script>


<style scoped lang="scss">
    .modal-content{
        width: 45%;
    }
    .close{
        color: #C4C4C4 !important;
    }
    .modal-title{
        text-align: left !important;
        padding-left: 1em;
        color: #A5B9D5 !important;
        font-size: 1.8em !important;
        font-family: Lato;
        text-transform: uppercase;
    }
    .modal-body {
        .form-group{
            span {
                font-size: 15px;
                padding-top: 5px;
                padding-left: 5px;
            }
        }

        .modal-loader{
            width: 100px;
        }

        label{
            font-weight: bold !important;
        }

        .info-text-connect{
            padding-bottom: 1em !important;
            text-align: left !important;
            font-family: "Lato" !important;
            font-weight: 600 !important;
        }

        .font-muli{
            font-family: 'Muli-Regular';
        }

        .font-mulish{
            font-family: 'Mulish';
            font-weight: 200 !important;
        }

        .bottom-buttons{
            text-align: center;
        }

        .btn__normal{
            margin: 12px;
            width: 170px;
            height: 40px;
        }
    }

    @media only screen and (max-width: 780px) {
        .modal-title{
            font-size: 1.3em !important;
            padding-left: 0 !important;
        }
        .modal-body{
            padding: 0 !important;
        }
    }

</style>


// WEBPACK FOOTER //
// resources/office/js/components/domains-storage/connectDomainFunnels.vue